<template>
  <div  class="flex items-center justify-center p-6 min-h-screen bg-indigo-800 relative overflow-hidden">
    <video autoplay muted  class="background-video">
      <source :src=videoUrl type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <Head title="Login" />
    <div class="w-full max-w-md content-overlay">
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" :rules="loginRules" @submit.prevent="handleLogin" >
        <div class="px-10 py-12">
          <h1 class="text-center text-3xl font-bold">  <logo class=" mx-auto w-full max-w-xs fill-white" height="90" /> Social Login</h1>
          <div class="mt-6 mx-auto w-24 border-b-2" />
        
          <text-input v-model="form.username" :error="form.errors.username" class="mt-10" label="Username" type="text" autofocus autocapitalize="off" />
          <div class="relative">
                <text-input
                  v-model="form.password"
                  
                  :error="form.errors.password"
                  class="mt-6"
                  label="Password"
                  :type="pwdType"
                  autocomplete
                />
                <button 
                  type="button"
                  @click="togglePasswordVisibility"
                  class="absolute right-3 top-3 show_pwd"
                  aria-label="Toggle password visibility"
                >
                  <span v-if="pwdType">👁️</span>
                  <span v-else>{{pwdType}}👁️‍🗨️</span>
                </button>
          </div>
          <!-- <label class="flex items-center mt-6 select-none" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
            <span class="text-sm">Remember Me</span>
          </label> -->

          <text-input v-model="form.otp" :error="form.errors.otp" class="mt-6" label="OTP"  type="number"
          placeholder="OTP (Google Auth)"
          />

        </div>
        <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Login</loading-button>
        </div>
      </form>
    </div> 
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
  },
  props: {
    videoUrl: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        username: undefined,
        password: undefined,
        otp: undefined,
        // remember: false,
      }),
      loginRules: {
        username: [{ type: "string", required: true, trigger: 'blur', }],
        password: [{ type: "string", required: true, trigger: 'blur' }],
        otp: [{ required: true, trigger: 'blur' }, { type: 'number', trigger: 'blur' }]
      },
      pwdType: 'password'
    }
  },
  methods: {
    handleLogin() {
      this.form.post('/login', {
        onError: () => {
          // Handle errors
          console.log(this.form.errors);
        }
      })
      // this.form.post('/login')
    },
    togglePasswordVisibility() {
      console.log('hi');
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }      
    },
  },
}
</script>
<style scoped>
.relative {
  position: relative;
}

.text-input {
  width: 100%;
  padding-right: 2.5rem; /* Add space for the icon */
}

.show_pwd {
  position: absolute;
  top: 60%;
  right: 0.75rem;
  transform: translateY(-50%);
  cursor: pointer;
}
.background-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Makes sure the video covers the entire div */
  /* z-index: -1; */
}

.content-overlay {
  position: relative;
  z-index: 10; /* Ensures content appears above the video */
}
</style>